export default __webpack_public_path__ + "static/media/2.9f9fd367.png";